import { Box, Stack, Text, TextLinkButton } from 'braid-design-system';
import type React from 'react';
import * as styles from './VerificationTooltipContent.css';
import HotjarMask from 'src/components/common/HotjarMask';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';
import { VerificationInfoItemList } from 'src/components/common/Certsy/VerificationInfoItemList';
import { JOB_APPLICATION_TAB } from 'src/constants/tabs';
import { useDeepLinkedDetailView } from 'src/pages/CandidateManagementPage/utils/useDeepLinkedDetailView';
import type { Verification } from '../../types';

interface ToolTipProps {
  verifications: Verification[];
  jobApplicationId: string;
}

const VerificationTooltipContent: React.FC<ToolTipProps> = ({
  verifications,
  jobApplicationId,
}) => {
  const { t } = useTranslations(translations);
  const { showDeepLinkedDetailView } = useDeepLinkedDetailView();
  const onClickLink = async () => {
    showDeepLinkedDetailView({
      jobApplicationId,
      tab: JOB_APPLICATION_TAB.PROFILE,
    });
  };

  return (
    <Box
      display="flex"
      height="full"
      width="full"
      flexDirection="column"
      className={[styles.toolTipWidth, styles.desktopWidth]}
    >
      <Stack space="large">
        {verifications.map((verification, index) => (
          <Stack space="gutter" key={index}>
            <Text weight="strong">
              <HotjarMask>{verification.title}</HotjarMask>
            </Text>
            <Stack space="small">
              <VerificationInfoItemList
                verificationInfo={verification.credentialInfo}
              />
            </Stack>
          </Stack>
        ))}
        <Text align="right">
          <TextLinkButton onClick={onClickLink}>
            {t('View full details in profile')}
          </TextLinkButton>
        </Text>
      </Stack>
    </Box>
  );
};

export default VerificationTooltipContent;
